<template>
  <div>
    <vx-card v-if="board" class="w-full">
      <div class="flex justify-between items-center">
        <h4>{{ $t('종사자 정보') }}</h4>
        <vs-button color="secondary" @click="onClickSave">{{ $t('저장') }}</vs-button>
      </div>
      <p class="mt-6 mb-5">{{ $t('※ 각 부서에서 관리감독자가 담당종사자를 엑셀파일로 대량 등록하는하는 페이지입니다.') }}<br />
        {{$t('※ 엑셀 템플릿을 다운받고, 종사자들의 사업장과 부서를 선택하여 선택한 데이터에 해당하는 엑셀파일을 작성하여 업로드합니다.')}}<br />
        {{$t('※ 최초 작성 후 변동사항이 생겼을 시 [종사자 등록] 메뉴에서 등록된 문서를 열어 수정하여 저장합니다.')}}
      </p>

      <!-- 기본정보 -->
      <field-select-module v-model="form.stdInfo" :board="board" :types="['department', 'com_name', 'rank', 'writer_name', 'date']" />

      <!-- 종사자 소속 지정 및 엑셀 업로드 -->
      <div>
        <h5 class="mt-6 mb-4"><i class="dot"></i>{{ $t('종사자 소속 지정 및 엑셀 업로드') }}</h5>
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>{{ $t('사업장명') }}</div>
            <field-selector :readonly="board.readonly" v-model="form.fields" />
          </div>
          <div>
            <div>{{ $t('부서') }}</div>
            <company-selector v-model="form.company" />
          </div>
          <!-- PC 레이아웃 - 파일 업로드 -->
          <div v-if="!isMobile" class="writeGridLineItem">
            <div>{{ $t('파일 업로드') }}</div>
            <div>
              <vs-button color="secondary" type="border" :href="excelTemplateUrl">{{ $t('엑셀 템플릿 다운로드') }}</vs-button>
              <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload">{{ $t('작성 엑셀 업로드') }}</vs-button>
              <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>

          <!-- Mobile 레이아웃 - 파일 업로드 -->
          <div v-if="isMobile" class="mobile-upload-row">
            <div class="mobile-upload-label">{{ $t('파일 업로드') }}</div>
            <div class="mobile-upload-buttons">
              <vs-button color="secondary" type="border" :href="excelTemplateUrl" class="mobile-upload-button">{{ $t('엑셀 템플릿 다운로드') }}</vs-button>
              <vs-button color="secondary" @click="onClickExcelUpload" class="mobile-upload-button">{{ $t('작성 엑셀 업로드') }}</vs-button>
              <input v-show="false" ref="excelInput" type="file" @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>

      <!-- 등록 대상 종사자 정보 -->
      <div>
        <!-- PC 레이아웃 헤더 -->
        <div v-if="!isMobile" class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i>{{ $t('등록 대상 종사자 정보') }}</h5>
          <vs-button color="secondary" type="border" @click="onClickCheckRemove">{{ $t('선택삭제') }}</vs-button>
        </div>

        <!-- 모바일 레이아웃 헤더 -->
        <div v-if="isMobile" class="mobile-employee-header">
          <h5><i class="dot"></i>{{ $t('등록 대상 종사자 정보') }}</h5>
          <div class="mobile-header-controls">
            <div class="mobile-select-all">
              <vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" />
              <span class="ml-2">{{ $t('전체선택') }}</span>
            </div>
            <vs-button color="secondary" type="border" @click="onClickCheckRemove" class="mobile-delete-btn">{{ $t('선택삭제') }}</vs-button>
          </div>
          <div v-if="checkList.length > 0" class="mobile-selected-count">
            {{ checkList.length }}개 선택됨
          </div>
        </div>

        <!-- PC 테이블 레이아웃 -->
        <div v-if="!isMobile" style="max-height: 1070px; overflow-y: auto">
          <table>
            <colgroup>
              <col width="60" />
              <col width="60" />
            </colgroup>
            <thead>
            <th><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></th>
            <th>No.</th>
            <th>{{ $t('ID(사번)') }}</th>
            <th>{{ $t('생년월일') }}</th>
            <th>{{ $t('구분') }}</th>
            <th>{{ $t('직종') }}</th>
            <th>{{ $t('직급') }}</th>
            <th>{{ $t('성명') }}</th>
            <th>{{ $t('최종 입사일') }}</th>
            <th>{{ $t('현보직일') }}</th>
            <th>{{ $t('연락처') }}</th>
            <th>{{ $t('퇴임일') }}</th>
            <th>{{ $t('수정/삭제') }}</th>
            </thead>
            <tbody>
            <tr v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
              <td><vs-checkbox :vs-value="excel_i" v-model="checkList" class="check" /></td>
              <td v-for="(_num, _num_i) in 11" :key="`${excel_i}_${excel[0]}_${_num_i}`">
                <div v-if="editExcelIndex === excel_i" class="p-1">
                  <DateSelector v-if="_num_i === 2 || _num_i === 6 || _num_i === 7 || _num_i === 9" v-model="editExcelData[_num_i]" class="w-full" />
                  <ml-input v-else v-model="editExcelData[_num_i]" class="w-full" />
                </div>
                <div v-else>
                  <p>{{ excel[_num_i] || "-" }}</p>
                  <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][_num_i]" class="errMsg">{{ errorMSG[excel_i][_num_i] }}</p>
                </div>
              </td>
              <td>
                <div class="flex justify-center gap-3">
                  <fragment v-if="editExcelIndex === excel_i">
                    <button @click="onClickFinshExcelData(excel_i)">
                      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickCancelExcelData(excel_i)">
                      <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                  <fragment v-else>
                    <button @click="onClickEditExcelData(excel_i)">
                      <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                    </button>
                    <button @click="onClickRemoveExcelData(excel_i)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                    </button>
                  </fragment>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- 모바일 카드 레이아웃 -->
        <div v-if="isMobile" class="mobile-employee-container">
          <div v-if="excelData.length === 0" class="mobile-empty-state">
            <div class="empty-content">
              <p>{{ $t('등록 대상 종사자 정보가 없습니다') }}</p>
              <p class="empty-description">{{ $t('엑셀 파일을 업로드해주세요') }}</p>
            </div>
          </div>

          <div v-else class="mobile-employee-cards">
            <div
              v-for="(excel, excel_i) in excelData"
              :key="`mobile_${excel_i}_${excel[0]}`"
              class="mobile-employee-card"
              :class="{ 'selected': checkList.includes(excel_i), 'editing': editExcelIndex === excel_i }"
            >
              <!-- 카드 헤더 -->
              <div class="card-header">
                <div class="card-checkbox">
                  <vs-checkbox :vs-value="excel_i" v-model="checkList" class="check" />
                </div>
                <div class="card-title">
                  <span class="employee-name">{{ excel[6] || $t('이름 없음') }}</span>
                  <span class="employee-number">No. {{ excel[0] || '-' }}</span>
                </div>
                <div class="card-actions">
                  <fragment v-if="editExcelIndex === excel_i">
                    <button @click="onClickFinshExcelData(excel_i)" class="mobile-action-btn save">
                      <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" />
                    </button>
                    <button @click="onClickCancelExcelData(excel_i)" class="mobile-action-btn cancel">
                      <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                    </button>
                  </fragment>
                  <fragment v-else>
                    <button @click="onClickEditExcelData(excel_i)" class="mobile-action-btn edit">
                      <feather-icon icon="Edit2Icon" svgClasses="h-4 w-4" />
                    </button>
                    <button @click="onClickRemoveExcelData(excel_i)" class="mobile-action-btn delete">
                      <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" />
                    </button>
                  </fragment>
                </div>
              </div>

              <!-- 카드 내용 -->
              <div class="card-content">
                <div class="employee-info-grid">
                  <!-- ID(사번) -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('ID(사번)') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <ml-input v-model="editExcelData[1]" class="w-full mobile-input" />
                      </div>
                      <div v-else>
                        <span>{{ excel[1] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][1]" class="errMsg">{{ errorMSG[excel_i][1] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 생년월일 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('생년월일') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <DateSelector v-model="editExcelData[2]" class="w-full" />
                      </div>
                      <div v-else>
                        <span>{{ excel[2] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][2]" class="errMsg">{{ errorMSG[excel_i][2] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 구분 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('구분') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <ml-input v-model="editExcelData[3]" class="w-full mobile-input" />
                      </div>
                      <div v-else>
                        <span>{{ excel[3] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][3]" class="errMsg">{{ errorMSG[excel_i][3] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 직종 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('직종') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <ml-input v-model="editExcelData[4]" class="w-full mobile-input" />
                      </div>
                      <div v-else>
                        <span>{{ excel[4] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][4]" class="errMsg">{{ errorMSG[excel_i][4] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 직급 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('직급') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <ml-input v-model="editExcelData[5]" class="w-full mobile-input" />
                      </div>
                      <div v-else>
                        <span>{{ excel[5] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][5]" class="errMsg">{{ errorMSG[excel_i][5] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 최종 입사일 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('최종 입사일') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <DateSelector v-model="editExcelData[7]" class="w-full" />
                      </div>
                      <div v-else>
                        <span>{{ excel[7] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][7]" class="errMsg">{{ errorMSG[excel_i][7] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 현보직일 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('현보직일') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <DateSelector v-model="editExcelData[8]" class="w-full" />
                      </div>
                      <div v-else>
                        <span>{{ excel[8] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][8]" class="errMsg">{{ errorMSG[excel_i][8] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 연락처 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('연락처') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <ml-input v-model="editExcelData[9]" class="w-full mobile-input" />
                      </div>
                      <div v-else>
                        <span>{{ excel[9] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][9]" class="errMsg">{{ errorMSG[excel_i][9] }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- 퇴임일 -->
                  <div class="info-item">
                    <div class="info-label">{{ $t('퇴임일') }}</div>
                    <div class="info-value">
                      <div v-if="editExcelIndex === excel_i">
                        <DateSelector v-model="editExcelData[10]" class="w-full" />
                      </div>
                      <div v-else>
                        <span>{{ excel[10] || "-" }}</span>
                        <p v-if="!!errorMSG[excel_i] && !!errorMSG[excel_i][10]" class="errMsg">{{ errorMSG[excel_i][10] }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelectorMultiple";
import CompanySelector from "@/components/selector/CompanySelector";
import DateSelector from "@/components/selector/DateSelector";
import XLSX from "xlsx";
import moment from "moment";
import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FieldSelectModule,
    FieldSelector,
    CompanySelector,
    DateSelector,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      // board: {
      //   projectTitle: this.$store.state.project.projectInfo.field_name,
      //   writer: {}, //작성자 정보
      //   readonly: false, // 읽기전용인가
      //   isPrint: false,
      //   viewSaveBtn: true,
      //   viewRemoveBtn: true,
      // },

      // 반응형 윈도우 크기 감지
      windowWidth: window.innerWidth,

      form: {
        stdInfo: {},
        fields: [],
        company: null,
      },

      editExcelIndex: null,
      editExcelData: [],
      excelData: [],
      checkList: [],

      errorMSG: [],
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    excelTemplateUrl() {
      return `${window.location.protocol}//${window.location.hostname}:8080/storage/app/media/%EC%A2%85%EC%82%AC%EC%9E%90_%EC%97%85%EB%A1%9C%EB%93%9C_%ED%85%9C%ED%94%8C%EB%A6%BF.xlsx`;
    },
  },
  created() {
    this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "종사자의견청취" }, { title: "종사자 정보", active: true }]);
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    readFile(event) {
      // get File object from input tag
      const file = event.target.files[0];
      const fileName = file.name;

      // declare FileReader, temp result
      const reader = new FileReader();
      let tmpResult = {};

      // if you use "this", don't use "function(e) {...}"
      reader.onload = (e) => {
        let data = e.target.result;
        data = new Uint8Array(data);
        // get excel file
        let excelFile = XLSX.read(data, { type: "array", cellDates: true });

        // get prased object
        excelFile.SheetNames.forEach(function (sheetName) {
          const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
          if (roa.length) tmpResult[sheetName] = roa;
        });
        let _data = tmpResult.Sheet1.filter((data, data_i) => data_i !== 0 && 0 < data.length);
        _data = _data.map((row) => {
          return row.map((item, item_i) => {
            let _item = item;
            if (item_i === 2 || item_i === 7 || item_i === 8 || item_i === 10) _item = this.setMoment(_item);
            else if (item_i === 9) _item = this.setPhone(_item);
            return _item;
          });
        });
        this.excelData = [...this.excelData, ..._data];
      };
      reader.readAsArrayBuffer(file);
    },
    setMoment(date) {
      let _date = date;
      if (typeof _date === "number") _date = `${_date}`;
      if (typeof _date === "string" && !_date.includes("-")) _date = `${_date.slice(0, 4)}-${_date.slice(4, 6)}-${_date.slice(6, 8)}`;
      return moment(_date).add(1, "days").format("YYYY-MM-DD");
    },
    setPhone(data) {
      let _data = `${data}`;
      if (typeof data === "number" && _data.length === 10 && _data.charAt(0) !== "0") _data = `0${_data}`;
      return _data.replace(/^(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    },
    onClickEditExcelData(index) {
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
      this.editExcelIndex = index;
      this.errorMSG = [];
    },
    onClickFinshExcelData(index) {
      const _data = this.editExcelData.map((item, item_i) => {
        if (item_i === 6 || item_i === 7 || item_i === 9) return !!item.trim() ? moment(item).format("YYYY-MM-DD") : "";
        else return item;
      });
      this.$set(this.excelData, index, _data);
      this.onClickCancelExcelData();
    },
    onClickCancelExcelData(index) {
      this.editExcelData = [];
      this.editExcelIndex = null;
      this.errorMSG = [];
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
      this.errorMSG = [];
    },
    checkAll() {
      if (0 < this.excelData.length && this.excelData.length === this.checkList.length) this.checkList = [];
      else this.checkList = this.excelData.map((_, i) => i);
    },
    onClickCheckRemove() {
      if (this.checkList.length < 1) return;
      this.excelData = this.excelData.filter((_, i) => !this.checkList.includes(i));
      this.checkList = [];
      this.errorMSG = [];
    },
    onClickSave() {
      // 사업장명이 선택이 안되어 있을때 에러
      if (this.form.fields.length < 1) {
        this.customAlert("사업장을 선택해주세요");
        return;
      }
      // 부서가 선택이 안되어 있을때 에러
      if (!this.form.company) {
        this.customAlert("부서를 선택해주세요");
        return;
      }
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.customAlert("등록 대상 종사자 정보가 없습니다");
        return;
      }
      // 종사자 정보에서 ID(사번)이 없는 데이터가 존재할때 에러
      const noneCodeData = this.excelData.filter((ed) => !ed[1]);
      if (0 < noneCodeData.length) {
        this.customAlert("ID(사번)이 없는 종사자 정보가 있습니다");
        return;
      }
      // 종사자 정보에서 ID(사번)이 중복되는 데이터가 존재할때 에러
      const codeData = this.excelData.map((ed) => ed[1]);
      const codeSet = new Set(codeData);
      if (codeData.length !== codeSet.size) {
        this.customAlert("ID(사번)이 중복되는 종사자 정보가 있습니다");
        return;
      }

      this.loading(true);

      const employees = this.excelData.map((ed) => {
        const obj = {
          no: ed[0] || null,
          employee_code: `${ed[1]}`,
          date_of_birth: ed[2] || "",
          job_category: ed[3] || "",
          employment_type: ed[4] || "",
          job_title: ed[5] || "",
          full_name: ed[6] || "",
          hire_date: ed[7] || "",
          current_position_date: ed[8] || "",
          contact_number: ed[9] || "",
          retirement_date: ed[10] || "",
        };
        return Object.entries(obj).reduce((acc, [k, v]) => (v ? { ...acc, [k]: v } : acc), {});
      });

      const option = {
        company_id: this.form.company,
        register_at: this.form.stdInfo.date,
        field_ids: this.form.fields.map((field) => field.id),
        employees,
      };

      HttpRequest.post(`/api/v1/employee/${this.projectId}/bulk`, option, true)
        .then((response) => {
          // 초기화
          this.form.fields = [];
          this.form.company = null;
          this.editExcelIndex = null;
          this.editExcelData = [];
          this.excelData = [];
          this.checkList = [];

          this.loading(false);
          this.customAlert("종사자 정보가 등록되었습니다", "종사자 등록");
        })
        .catch(({ response }) => {
          this.loading(false);
          if (typeof response.data === "string") {
            const err = JSON.parse(response.data);
            this.errorMSG = err.map((_e) => {
              const { no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e.error;
              return [no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
            });
          } else if (typeof response.data === "object") {
            const errArray = [];
            const err = response.data;
            for (const _t in err) {
              const key = _t.split(".");
              errArray[key[1]] = { ...errArray[key[1]], ...{ [key[2]]: err[_t] } };
            }

            this.errorMSG = errArray.map((_e) => {
              const { no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e;
              return [no, employee_code, date_of_birth, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
            });
          }
        });
    },
    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: !!title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    padding: 0;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
    padding: 16px 0;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}
.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}

/* 모바일 파일 업로드 스타일 */
.mobile-upload-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  min-height: 44px; /* 터치 친화적 최소 높이 */
}

.mobile-upload-label {
  flex-shrink: 0;
  min-width: 60px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  padding-top: 12px; /* 버튼과 높이 맞춤 */
}

.mobile-upload-buttons {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.mobile-upload-button {
  width: 100% !important;
  min-height: 44px !important; /* 터치 친화적 높이 */
  font-size: 14px !important;
}

/* 모바일 종사자 정보 스타일 */
.mobile-employee-header {
  margin: 24px 0 16px 0;
}

.mobile-header-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  gap: 16px;
}

.mobile-select-all {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.mobile-delete-btn {
  min-height: 36px !important;
  font-size: 13px !important;
}

.mobile-selected-count {
  margin-top: 8px;
  font-size: 12px;
  color: #7e72f2;
  font-weight: 500;
}

.mobile-employee-container {
  margin-top: 16px;
}

.mobile-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.empty-content {
  text-align: center;
}

.empty-content p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.empty-description {
  font-size: 12px !important;
  color: #999 !important;
  margin-top: 4px !important;
}

.mobile-employee-cards {
  display: flex;
  flex-direction: column;
  gap: 10px; /* 12px에서 10px로 감소 */
  max-height: 80vh; /* 70vh에서 75vh로 증가 */
  overflow-y: auto;
  padding-bottom: 80px; /* 플로팅 버튼과의 간섭 방지 */
}

.mobile-employee-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  overflow: hidden;
}

.mobile-employee-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.mobile-employee-card.selected {
  border-color: #7e72f2;
  background: #f8f7ff;
}

.mobile-employee-card.editing {
  border-color: #28a745;
  background: #f8fff9;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  gap: 12px;
}

.card-checkbox {
  flex-shrink: 0;
}

.card-title {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.employee-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.3;
}

.employee-number {
  font-size: 12px;
  color: #666;
  font-weight: 400;
}

.card-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.mobile-action-btn {
  width: 36px !important;
  height: 36px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-action-btn.edit {
  border-color: #7e72f2;
  color: #7e72f2;
}

.mobile-action-btn.edit:hover {
  background: #7e72f2;
  color: #fff;
}

.mobile-action-btn.delete {
  border-color: #ea5455;
  color: #ea5455;
}

.mobile-action-btn.delete:hover {
  background: #ea5455;
  color: #fff;
}

.mobile-action-btn.save {
  border-color: #28a745;
  color: #28a745;
}

.mobile-action-btn.save:hover {
  background: #28a745;
  color: #fff;
}

.mobile-action-btn.cancel {
  border-color: #6c757d;
  color: #6c757d;
}

.mobile-action-btn.cancel:hover {
  background: #6c757d;
  color: #fff;
}

.card-content {
  padding: 12px 16px; /* 상하 패딩을 16px에서 12px로 감소 */
}

.employee-info-grid {
  display: flex;
  flex-direction: column;
  gap: 6px; /* 12px에서 6px로 감소 */
}

.info-item {
  display: grid;
  grid-template-columns: 75px 1fr; /* 80px에서 75px로 감소 */
  gap: 8px; /* 12px에서 8px로 감소 */
  align-items: flex-start;
  min-height: 30px; /* 36px에서 30px로 감소 */
}

.info-label {
  font-size: 12px; /* 13px에서 12px로 감소 */
  font-weight: 500;
  color: #555;
  line-height: 1.3; /* 1.4에서 1.3으로 감소 */
  padding-top: 6px; /* 8px에서 6px로 감소 */
}

.info-value {
  display: flex;
  flex-direction: column;
  gap: 2px; /* 4px에서 2px로 감소 */
}

.info-value span {
  font-size: 13px; /* 14px에서 13px로 감소 */
  color: #333;
  line-height: 1.3; /* 1.4에서 1.3으로 감소 */
  padding: 4px 0; /* 6px에서 4px로 감소 */
  word-break: break-all;
}

.mobile-input {
  font-size: 13px !important; /* 14px에서 13px로 감소 */
  min-height: 32px !important; /* 36px에서 32px로 감소 */
}

/* 인쇄 시 모바일 레이아웃 숨기기 */
@media print {
  .mobile-upload-row,
  .mobile-employee-container,
  .mobile-employee-header {
    display: none !important;
  }
}
</style>
